var map = {
	"./1 1.png": 46396,
	"./5.png": 72640,
	"./59945-success-confetti.gif": 87818,
	"./9MOBILE.png": 12907,
	"./AIRTEL.png": 28441,
	"./Adobe.png": 94133,
	"./Airbnb.png": 82114,
	"./Allura Online Searching.png": 6803,
	"./Amazon.png": 37156,
	"./Analythics.png": 31066,
	"./ArrowLeft.png": 87067,
	"./ArrowRight.png": 14345,
	"./Arrows4.png": 57164,
	"./Canva.png": 60676,
	"./Contact-Us-(1).png": 20013,
	"./Contact_Us.png": 33934,
	"./Demo.png": 54686,
	"./Ellipse 10.png": 25560,
	"./Ellipseleft.png": 83850,
	"./Ellipseright.png": 3626,
	"./Expedia.png": 97136,
	"./Facebook.png": 52650,
	"./Finance.png": 84433,
	"./Frame 5 (1).png": 22697,
	"./Frame 5 (2).png": 97495,
	"./Frame 5 (3).png": 11810,
	"./Frame 5 (4).png": 63909,
	"./Frame 5.png": 48164,
	"./Frame33.png": 35725,
	"./Frame44.png": 52345,
	"./Frame55.png": 42317,
	"./Frame66.png": 49505,
	"./Frame77.png": 37657,
	"./FrameOne.png": 32880,
	"./FrameTwo.png": 92362,
	"./Fresh Folk Teamwork.png": 27234,
	"./GLO.png": 69365,
	"./Grammaly.png": 76158,
	"./Group (3).png": 19603,
	"./Group (4).png": 57782,
	"./Group (5).png": 92686,
	"./Group 1 (1).png": 26090,
	"./Group 42903.png": 20866,
	"./Group 42924.png": 63555,
	"./HFfacebook.png": 60233,
	"./HFlinkedin.png": 2485,
	"./HFmessenger.png": 57652,
	"./HFtwitter.png": 43895,
	"./HThirteenArrow.png": 9092,
	"./HThirteenChart.png": 6518,
	"./HThirteenEllipse4.png": 34087,
	"./HThirteenFrame74.png": 78399,
	"./HThirteenGroup.png": 42683,
	"./HThirteenGroup42945.png": 20356,
	"./HThirteenGroup43024.png": 24319,
	"./HThirteenGroup6.png": 56143,
	"./HThirteenGroup8.png": 33085,
	"./HThirteenIcon.png": 55560,
	"./HThirteenVector.png": 84022,
	"./HThirteenbg.png": 97669,
	"./Hands Give.png": 46242,
	"./HeightBlurHero.png": 25982,
	"./HeightGroup.png": 58015,
	"./HeightHero.png": 21578,
	"./HeightStar.png": 87831,
	"./HeightTImage.png": 47477,
	"./Heightarrow.png": 78418,
	"./Heightarrowcircleup.png": 53307,
	"./HeightfIcon.png": 9144,
	"./HeightiPhone12.png": 56390,
	"./Heighticon1.png": 2424,
	"./Heighticon2.png": 91248,
	"./Heighticon3.png": 21429,
	"./Heighticon4.png": 95480,
	"./Heighticon5.png": 82274,
	"./Heighticon6.png": 34301,
	"./Heightquotedown.png": 66462,
	"./Heleven1.png": 86054,
	"./Heleven10.png": 67942,
	"./Heleven11.png": 30241,
	"./Heleven13.png": 43142,
	"./Heleven14.png": 63662,
	"./Heleven15.png": 84540,
	"./Heleven16.png": 80393,
	"./Heleven17.png": 13522,
	"./Heleven2.png": 27190,
	"./Heleven3.png": 3637,
	"./Heleven4.png": 7242,
	"./Heleven5.png": 6990,
	"./Heleven6.png": 68662,
	"./Heleven66.png": 37444,
	"./Heleven7.png": 85995,
	"./Heleven8.png": 21945,
	"./Heleven9.png": 85870,
	"./HelevenAirtime.png": 37204,
	"./HelevenFacebook.png": 50602,
	"./HelevenHero.png": 73529,
	"./HelevenInstagram.png": 85477,
	"./HelevenVector copy.png": 52177,
	"./HelevenVector.png": 35882,
	"./Helevencon.png": 74543,
	"./Helevenpas.png": 16853,
	"./Helevenpas2.png": 23015,
	"./Helevenpas4.png": 83081,
	"./Heleventwitter.png": 29122,
	"./HnineFrame4.png": 9754,
	"./HnineGroup2.png": 23527,
	"./HnineGroup4.png": 27125,
	"./HnineGroup42.png": 85892,
	"./HnineGroup66.png": 94023,
	"./HnineGroupface.png": 10976,
	"./HnineGroupinsta.png": 59089,
	"./HnineGrouptwit.png": 89490,
	"./HnineLine79.png": 60464,
	"./HnineVector.png": 80171,
	"./Hninequotedown.png": 49727,
	"./Hninequoteup.png": 49365,
	"./Hninescrolleft.png": 5158,
	"./Hninescrollright.png": 87186,
	"./Hninetestim.jpeg": 17617,
	"./Hokmefifteenglo.png": 1958,
	"./HomeFifHero.png": 95665,
	"./HomeFifteentHero.png": 73758,
	"./HomeFourAvatar.png": 96945,
	"./HomeFourHarr.png": 50679,
	"./HomeFourImg.png": 27824,
	"./HomeFourRect.png": 31756,
	"./HomeSevenHerroBg.png": 74881,
	"./HomeSixteenGooglePlay.png": 84160,
	"./HomeSixteenLogo.png": 19652,
	"./HomeSixteenMockupImageOne.png": 44586,
	"./HomeSixteenMockupImageThree.png": 30257,
	"./HomeSixteenMockupImageTwo.png": 82024,
	"./HomeSixteenOptimizeImage.jfif": 3169,
	"./Homefif9mobile.png": 96937,
	"./Homefifteenairtel.png": 63098,
	"./Homefifteenmtn.png": 56379,
	"./HomefiveArrow.png": 99682,
	"./HomefiveFrame.png": 60500,
	"./HomefiveHerroImg.png": 66550,
	"./HomefiveLine.png": 36005,
	"./HomefiveTestimg.png": 67765,
	"./HomefiveTimg.png": 25562,
	"./Homeonelogo.png": 89800,
	"./HoneArrow.png": 33566,
	"./HoneArrow2.png": 20599,
	"./HoneFirstcad.png": 60170,
	"./HoneHerro.png": 69586,
	"./HsevenArr.png": 268,
	"./HsevenFacebook.png": 67672,
	"./HsevenFooter.jpg": 95684,
	"./HsevenFooterLine.png": 84144,
	"./HsevenInstagram.png": 64318,
	"./HsevenLeftarrow.png": 19502,
	"./HsevenLine.png": 35721,
	"./HsevenRatting.png": 79092,
	"./HsevenRightarrow.png": 89128,
	"./HsevenTline.png": 24927,
	"./HsevenTwiter.png": 73836,
	"./HsevenWoman.png": 77791,
	"./Hsevenicon.png": 55481,
	"./HsevenredArrow.png": 86140,
	"./Hseventestyfour.jpg": 67425,
	"./Hseventestyone.jpg": 14925,
	"./Hseventestythree.jpg": 95489,
	"./Hseventestytwo.jpg": 73647,
	"./HsixArrow.png": 33115,
	"./HsixArrow1.png": 98871,
	"./HsixAvatar.png": 53996,
	"./HsixFrame.png": 76593,
	"./HsixFrame2.png": 66191,
	"./HsixGroup1.png": 68876,
	"./HsixGroup2.png": 28226,
	"./HsixHero.png": 47249,
	"./HsixIcon1.png": 53812,
	"./HsixLine.png": 53575,
	"./HsixLine7.png": 82083,
	"./HsixRating.png": 47962,
	"./HsixRectangle.png": 96149,
	"./HsixRectangle1.png": 94593,
	"./HsixRectangle2.png": 31965,
	"./HsixRectangle3.png": 50403,
	"./HsixRectangle4.png": 43019,
	"./HsixRectangle5.png": 21924,
	"./HsixRectangle6.png": 35164,
	"./HsixSmiling.png": 51806,
	"./Hsixicon2.png": 52384,
	"./HtenHero.png": 23886,
	"./HtwelveAvatar.png": 37533,
	"./HtwelveT.png": 72070,
	"./HtwelveTechac.png": 46207,
	"./HtwelveVector2.png": 33418,
	"./Htwelvecool.png": 90069,
	"./Htwelvedown.png": 9578,
	"./Htwelveic.png": 34749,
	"./Htwelveic2.png": 1361,
	"./Htwelveline.png": 29278,
	"./Htwelveline2.png": 31267,
	"./Htwelveuser.png": 57473,
	"./Htwelvewi.png": 60602,
	"./Htwelve“.png": 75104,
	"./HwLogo.png": 4675,
	"./Icon1.png": 2861,
	"./Icon2.png": 98686,
	"./Increase.png": 10610,
	"./Interestrate.png": 60451,
	"./LeftBorder.png": 32864,
	"./Linkedin.png": 24582,
	"./MOAVOXPAY.png": 39646,
	"./MTN.png": 79310,
	"./Messenger.png": 15250,
	"./Money.png": 37068,
	"./Netflix.png": 36551,
	"./Olá Playing Video Games.png": 57493,
	"./Other 09.png": 58488,
	"./Other 17.png": 56082,
	"./Rectangle 373.png": 97606,
	"./RectangleT.png": 82549,
	"./Rectangle_373.png": 63915,
	"./Rectangles1.png": 25454,
	"./Saly-13@2x.png": 71318,
	"./Saly-21.png": 46914,
	"./Saly-22.png": 18598,
	"./Saly-24.png": 85853,
	"./Saly-25.png": 7293,
	"./Saly-26 (1).png": 9617,
	"./Saly-26.png": 44451,
	"./Saly-31.png": 51664,
	"./Saly-42.png": 63236,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Black.otf": 35179,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-BlackItalic.otf": 82996,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Bold.otf": 30902,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-BoldItalic.otf": 734,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Italic.otf": 35632,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Light.otf": 59616,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-LightItalic.otf": 82484,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Medium.otf": 5433,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-MediumItalic.otf": 79146,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Regular.otf": 54239,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/Variable/Satoshi-Variable.ttf": 22618,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/Variable/Satoshi-VariableItalic.ttf": 29706,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/README.md": 51639,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/css/satoshi.css": 922,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Black.eot": 23509,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Black.ttf": 31711,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Black.woff": 70941,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Black.woff2": 59837,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BlackItalic.eot": 14882,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BlackItalic.ttf": 13507,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BlackItalic.woff": 75046,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BlackItalic.woff2": 29470,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Bold.eot": 54175,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Bold.ttf": 25740,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Bold.woff": 83169,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Bold.woff2": 7362,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BoldItalic.eot": 85291,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BoldItalic.ttf": 81596,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BoldItalic.woff": 67975,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BoldItalic.woff2": 3926,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Italic.eot": 86821,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Italic.ttf": 5561,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Italic.woff": 13470,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Italic.woff2": 70655,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Light.eot": 48353,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Light.ttf": 74454,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Light.woff": 43221,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Light.woff2": 38642,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-LightItalic.eot": 29126,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-LightItalic.ttf": 90778,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-LightItalic.woff": 62618,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-LightItalic.woff2": 31818,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Medium.eot": 40271,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Medium.ttf": 19417,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Medium.woff": 26996,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Medium.woff2": 3464,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-MediumItalic.eot": 43409,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-MediumItalic.ttf": 88958,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-MediumItalic.woff": 38985,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-MediumItalic.woff2": 21416,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Regular.eot": 60297,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Regular.ttf": 81642,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Regular.woff": 20907,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Regular.woff2": 3685,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Variable.eot": 8049,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Variable.ttf": 72651,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Variable.woff": 40412,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Variable.woff2": 53254,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-VariableItalic.eot": 3847,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-VariableItalic.ttf": 93131,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-VariableItalic.woff": 56651,
	"./Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-VariableItalic.woff2": 67467,
	"./Satoshi_Complete/Satoshi_Complete/License/FFL.txt": 49632,
	"./Shield.png": 24988,
	"./Stuck at Home Mailing List.png": 78406,
	"./Support.png": 46354,
	"./TEllipse.png": 41798,
	"./TFrame.png": 72454,
	"./Tag.png": 22767,
	"./Tranc1.png": 14026,
	"./Tranc2.png": 5253,
	"./Tranc3.png": 47504,
	"./Trance4.png": 62641,
	"./Twitter.png": 8106,
	"./V12Line.png": 16267,
	"./Vector4.png": 50285,
	"./aboutimg.png": 61585,
	"./airtimeimg.png": 36587,
	"./amico.png": 84343,
	"./avatar3.png": 87169,
	"./brand-dark.png": 37690,
	"./brand-white.png": 65703,
	"./dataomg.png": 22985,
	"./dean-logo.png": 34669,
	"./educationimg.png": 37168,
	"./empty.png": 2158,
	"./faceimg.svg": 19264,
	"./footeromg.png": 93991,
	"./get-started.png": 19696,
	"./google.svg": 28489,
	"./grad-bg.png": 88330,
	"./heightLogo.png": 2157,
	"./hero-img-1.png": 67317,
	"./hero-img-2.png": 47916,
	"./hime-three-benefit.png": 83830,
	"./home-one-about-us.png": 82246,
	"./home-one-feature.png": 68038,
	"./home-one-hero.png": 62961,
	"./home-three-cta.png": 6394,
	"./home-three-customer.png": 33750,
	"./home-three-header-bg.png": 71184,
	"./home-three-hero.png": 32187,
	"./home-three-serv1.png": 12779,
	"./home-three-serv2.png": 79575,
	"./home-two-bg.png": 52690,
	"./home-two-feature.png": 52127,
	"./home-two-hero.png": 9673,
	"./hometwentyarror.png": 57130,
	"./homnineteenhero.png": 81253,
	"./htwentyhero.png": 93575,
	"./ico-1.png": 48218,
	"./ico-2.png": 12339,
	"./ico-3.png": 59079,
	"./ico-4.png": 67298,
	"./ico-5.png": 49607,
	"./ico-6.png": 9473,
	"./icon33.png": 52205,
	"./icon44.png": 44490,
	"./icon55.png": 25774,
	"./icon66.png": 59058,
	"./icon77.png": 58158,
	"./icons8-cancel.gif": 49099,
	"./img/benefits-bg.png": 4959,
	"./img/benefits-hero.png": 60384,
	"./img/customer.png": 31592,
	"./img/deal-hero.png": 29777,
	"./img/footer-bg.jpeg": 93031,
	"./img/footer-bg.png": 40953,
	"./img/hero.png": 43660,
	"./img/ico-1.png": 53148,
	"./img/ico-2.png": 80726,
	"./img/ico-3.png": 12715,
	"./img/ico-4.png": 71710,
	"./img/ico-5.png": 39267,
	"./img/ico-6.png": 80686,
	"./img/icon-1.png": 27122,
	"./img/icon-2.png": 73238,
	"./img/icon3.png": 72677,
	"./instaimg.png": 25456,
	"./ios.svg": 96494,
	"./kemtech_header_img.png": 97971,
	"./logo.png": 42354,
	"./man-in-office.jfif": 32711,
	"./map.png": 57644,
	"./orderimg.png": 88582,
	"./original-e0e275874b52009a537484d7785b9fa0 1.png": 72858,
	"./playstore.png": 32728,
	"./rate.png": 47268,
	"./sansation/Sansation_1.31_ReadMe.txt": 11647,
	"./sansation/Sansation_Bold.ttf": 76160,
	"./sansation/Sansation_Bold_Italic.ttf": 2807,
	"./sansation/Sansation_Italic.ttf": 5794,
	"./sansation/Sansation_Light.ttf": 36465,
	"./sansation/Sansation_Light_Italic.ttf": 29051,
	"./sansation/Sansation_Regular.ttf": 42862,
	"./sansation/Sansation_plate.jpg": 85303,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Black.otf": 73690,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-BlackItalic.otf": 68789,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Bold.otf": 29006,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-BoldItalic.otf": 77296,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Italic.otf": 68481,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Light.otf": 91137,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-LightItalic.otf": 94986,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Medium.otf": 34393,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-MediumItalic.otf": 964,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/OTF/Satoshi-Regular.otf": 62608,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/Variable/Satoshi-Variable.ttf": 81198,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/Variable/Satoshi-VariableItalic.ttf": 97859,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/README.md": 60754,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/css/satoshi.css": 85444,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Black.eot": 14358,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Black.ttf": 15030,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Black.woff": 19621,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Black.woff2": 923,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BlackItalic.eot": 74770,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BlackItalic.ttf": 59978,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BlackItalic.woff": 24747,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BlackItalic.woff2": 45003,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Bold.eot": 40061,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Bold.ttf": 30751,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Bold.woff": 74271,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Bold.woff2": 39700,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BoldItalic.eot": 78894,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BoldItalic.ttf": 28316,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BoldItalic.woff": 69610,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-BoldItalic.woff2": 25168,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Italic.eot": 98079,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Italic.ttf": 50930,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Italic.woff": 90903,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Italic.woff2": 1435,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Light.eot": 19751,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Light.ttf": 29291,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Light.woff": 94743,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Light.woff2": 82892,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-LightItalic.eot": 30582,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-LightItalic.ttf": 90585,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-LightItalic.woff": 40608,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-LightItalic.woff2": 51549,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Medium.eot": 90573,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Medium.ttf": 92921,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Medium.woff": 97028,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Medium.woff2": 31113,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-MediumItalic.eot": 84294,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-MediumItalic.ttf": 19506,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-MediumItalic.woff": 89313,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-MediumItalic.woff2": 22805,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Regular.eot": 77497,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Regular.ttf": 43677,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Regular.woff": 82788,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Regular.woff2": 93696,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Variable.eot": 25670,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Variable.ttf": 61998,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Variable.woff": 97202,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-Variable.woff2": 26590,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-VariableItalic.eot": 97649,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-VariableItalic.ttf": 22831,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-VariableItalic.woff": 34258,
	"./sansation/Satoshi_Complete/Satoshi_Complete/Fonts/WEB/fonts/Satoshi-VariableItalic.woff2": 63076,
	"./sansation/Satoshi_Complete/Satoshi_Complete/License/FFL.txt": 93501,
	"./services-two.png": 19995,
	"./testimg.png": 70256,
	"./testimony-img-1.png": 98747,
	"./tvimg.png": 9386,
	"./twentyonearrow.png": 20746,
	"./twentytimage.png": 54480,
	"./twiterimg.svg": 344,
	"./usertest.png": 66536,
	"./v12Group.png": 95339,
	"./v12Group2.png": 95371,
	"./v12Group3.png": 78333,
	"./v12Group4.png": 93902,
	"./v12Group5.png": 40495,
	"./v12Group6.png": 48281,
	"./v12Heroing.png": 83056,
	"./v12Icon.png": 85300,
	"./v12Line8.png": 27491,
	"./v12check.png": 18244,
	"./v12facebook.png": 20542,
	"./v12instagram.png": 38981,
	"./v12paylogo.png": 21222,
	"./v12phoneimg.png": 40269,
	"./v12whiteIcon.png": 40205,
	"./vec1.png": 1872,
	"./vec2.png": 27719,
	"./vec3.png": 57747,
	"./vec5.png": 33603,
	"./vec6.png": 73763,
	"./vec7.png": 75314,
	"./vic1.png": 8834,
	"./vic2.png": 76582,
	"./vic3.png": 89112,
	"./vic4.png": 3858,
	"./woman-pressing-phone.jfif": 47129,
	"./x36.png": 2669,
	"./Сoding.png": 11278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55160;